import "./IconTwoUsersNav.scss";
import { ReactComponent as TwoUsersNavIcon } from "./svg/iconTwoUsersNav.svg";
import { ReactComponent as TwoUsersNavIconFilled } from "./svg/iconTwoUsersNavFilled.svg";

interface Props {
  color?: "orange" | "gray" | "green" | "white" | "indigo";
  variant?: "outline" | "filled";
}

export const IconTwoUsersNav = ({ color = "gray", variant = "outline" }: Props) => {
  return (
    <span className={`icon-two-users-nav icon-two-users-nav--${color}`}>
      {variant === "outline" ? <TwoUsersNavIcon /> : <TwoUsersNavIconFilled />}
    </span>
  );
};
